module.exports = __webpack_public_path__ + "img/banner-full-small.12a4ea58.png";